import type { LoginFormProps } from '../../types/authForms';
import { type ComponentType } from 'react';
import { MARKETPLACE_AUTH_MODEL, SKIN, type MarketplaceAuthModel } from '../../types/enums';
import LoginForm from '../../components/organisms/LoginForm';
import RegisterForm, { type RegisterFormProps } from '../../components/organisms/RegisterForm';
import ForgotPasswordForm from '../../components/organisms/password-forms/ForgotPasswordForm';
import NeobetLoginForm from '../../components/skins/neobet/organisms/LoginForm';
import NeobetRegisterForm from '../../components/skins/neobet/organisms/RegisterForm';
import NeobetForgotPasswordForm from '../../components/skins/neobet/organisms/password-forms/ForgotPasswordForm';
import { SkinnedHybridLoginForm, SkinnedCreateBOUsersForm } from './components';
import { createSkinComponent } from '../../utils/skinComponent';

export type AuthFormsConfig = {
  loginFormsByModel: Partial<Record<MarketplaceAuthModel, ComponentType<LoginFormProps>>>;
  RegisterForm: ComponentType<RegisterFormProps>;
  ForgotPasswordForm: ComponentType;
  CreateBOUsersForm: ComponentType;
};

const SkinnedLoginForm = createSkinComponent(LoginForm, {
  [SKIN.NEOBET]: NeobetLoginForm,
});

const SkinnedRegisterForm = createSkinComponent(RegisterForm, {
  [SKIN.NEOBET]: NeobetRegisterForm,
});

const SkinnedForgotPasswordForm = createSkinComponent(ForgotPasswordForm, {
  [SKIN.NEOBET]: NeobetForgotPasswordForm,
});

export const authFormsConfig: AuthFormsConfig = {
  loginFormsByModel: {
    [MARKETPLACE_AUTH_MODEL.USER_REGISTRATION]: SkinnedLoginForm,
    [MARKETPLACE_AUTH_MODEL.HYBRID]: SkinnedHybridLoginForm,
  },
  RegisterForm: SkinnedRegisterForm,
  ForgotPasswordForm: SkinnedForgotPasswordForm,
  CreateBOUsersForm: SkinnedCreateBOUsersForm,
};
